// Diccionario temporal de mensajes de registro personalizados por programId.
// TODO: esto se va a mover al servidor más adelante; por ahora se mantiene acá.
// Si el programId del viaje elegido matchea una entrada, se muestra ese mensaje
// en la pantalla de "Registro completado". Si no matchea ninguna, se usa el
// mensaje por defecto del componente.
// Estos mismos programIds también ocultan el plan de pagos (PaymentPlanTable)
// en PassengerTripDetails y CreatePayment.
const registrationMessagesByProgram = {
  32: "Registro completado exitosamente!",
};

export const getRegistrationMessage = (programId) => {
  if (programId == null) return null;
  return registrationMessagesByProgram[programId] || null;
};

export const hasCustomRegistrationFlow = (programId) => {
  if (programId == null) return false;
  return Object.prototype.hasOwnProperty.call(
    registrationMessagesByProgram,
    programId,
  );
};

// El plan de pagos también se oculta para los viajes de "Campamentos",
// independientemente de si el programId matchea el diccionario de arriba
// (útil cuando el programId no viene definido pero sí el nombre del programa).
export const shouldHidePaymentPlan = ({
  programId,
  programName,
  tripId,
} = {}) => {
  return tripId === 108 || tripId === 110;
};

export default registrationMessagesByProgram;
